<template>
	<label class="checkbox-container ml-2" @click.stop>
		<input type="checkbox" v-model="state" @change="updateState" :tabindex="tabIndex" />
		<span v-if="!icon" class="checkmark"></span>
		<icon v-else title="قفل" icon="lock" :group="state ? 'solid' : 'regular'" class=" primary-light 	p-1" :class="{ 'borderPrimary-light': state }" style="scale: 0.65	" ref="generalSearch" />

	</label>
</template>

<script>
	export default {
		name: "small-checkbox",
		emits: ['update:modelValue'],
		props: {
			checked: Boolean,
			icon: String,
			tabIndex: Number
		},
		watch: {
			checked: {
				immediate: true,
				deep: true,
				handler(val) {
					this.state = val
				}
			}
		},
		data() {
			return {
				state: false,
			}
		},
		methods: {
			updateState(e) {
				this.$emit('update:modelValue', e.target.checked)
			}
		}
	}
</script>

<style scoped></style>